import { useEffect } from "react";
import { API_CHARTS_OF_ACCOUNTS } from "../../utils/apis";
import { getRegister, getResultOptions } from "../../utils/helpers";
import { URL_CHARTS_CONFIGURABLES } from "../../utils/urls";
import useGet from "../common/useGet";

export const useChartsOfAccountConfigurablesForm = ({ form }) => {
  const sections = [
    {
      title: "Configurable Details",
      fields: [
        {
          field_name: "account_type",
          type: "select",
          label: "Account Type",
          props: { required: true },
          options_data: [
            { id: "assets", name: "Assets" },
            { id: "liabilities", name: "Liabilities" },
            { id: "equity", name: "Equity" },
            { id: "expense", name: "Expenses" },
            { id: "income", name: "Income" },
            // { id: "current_asset", name: "Current Asset" },
            // { id: "fixed_asset", name: "Fixed Asset" },
            // { id: "current_liability", name: "Current Liability" },
            // { id: "non_current_liability", name: "Non Current Liability" },
          ],
        },
        {
          field_name: "parent_account",
          type: "select",
          label: "Parent Account",
          options_name: "accounts",
        },
        {
          field_name: "general_ledger_code",
          type: "number",
          label: "General Ledger Code",
          props: { required: true },
        },
        {
          field_name: "account_name",
          type: "text",
          label: "Account Name",
          props: { required: true },
        },
        {
          field_name: "description",
          type: "textarea",
          label: "Description",
        },
        {
          field_name: "category",
          type: "select",
          label: "Category",
          props: { required: true },
          options_data: [
            { id: "root", name: "Root" },
            { id: "header", name: "Header" },
            { id: "detail", name: "Detail" },
          ],
        },
        {
          field_name: "level",
          type: "select",
          label: "Level",
          props: { required: true },
          options_data: [
            { id: 1, name: "1" },
            { id: 2, name: "2" },
            { id: 3, name: "3" },
          ],
        },
      ],
    },
  ];

  const redirect = getRegister(URL_CHARTS_CONFIGURABLES);
  const getConfigOptions = () => {
    const { loadData: getAccounts, data: accounts } = useGet();

    useEffect(() => {
      getAccounts({
        api: `accounting/charts-of-accounts/all/?account_type=${form?.account_type}`,
      });
    }, [form?.account_type]);

    return {
      accounts: getResultOptions(accounts, "account_name"),
    };
  };
  const options = getConfigOptions();

  return {
    sections,
    redirect,
    options,
  };
};

export function submitCOAConfigurables(payload: any, id: string) {
  //  on update
  if (id) {
    return {
      id,
      api: API_CHARTS_OF_ACCOUNTS,
      params: payload,
    };
  }
  // on create
  return {
    api: API_CHARTS_OF_ACCOUNTS,
    params: payload,
  };
}
